import React from 'react';
import classes from './SupportFileCard.module.css';
import playIcon from '../../../assets/icons/play-video.svg';
import { SupportItemType } from '../../../screens/Support/Support';
import documentIcon from '../../../assets/icons/document-icon.svg';

type Props = {
  item: SupportItemType;
  selectedFile: SupportItemType | undefined;
  handleFileSelect: () => void;
};

const SupportFileCard: React.FC<Props> = ({ item, selectedFile, handleFileSelect }) => {
  return (
    <div
      className={classes.container}
      style={{
        background:
          selectedFile?.File?.data?.attributes?.url === item.File.data.attributes.url
            ? '#F4F7FE'
            : '#fff',
      }}
    >
      <div className={classes.playList} onClick={() => handleFileSelect()}>
        <div className={classes.position}>
          <span>{item?.Position}</span>
        </div>
        {(item.File.data.attributes.mime === 'video/mp4' ||
          item.File.data.attributes.mime === 'video/webm') && (
          <div className={classes.videoContainer}>
            <video height={80} src={`${item.File?.data?.attributes?.url}`} />
            <div className={classes.videoOverlay} />
            <div className={classes.playIcon}>
              <img src={playIcon} alt={'play'} height={30} />
            </div>
          </div>
        )}
        {item.File.data.attributes.mime === 'application/pdf' && (
          <div className={classes.videoContainer}>
            <div className={classes.videoOverlay} />
            <img alt={'document'} src={documentIcon} height={80} width={140} />
          </div>
        )}
      </div>
      <div className={classes.videoDescriptionContainer}>
        <div className={classes.title}>{item?.Title}</div>
        <div className={classes.grayLabel}>{item?.ShortDescription}</div>
        <div className={classes.time}>
          {item.VideoLength} <span style={{ marginLeft: 0 }}>seconds</span>
        </div>
      </div>
    </div>
  );
};

export { SupportFileCard };
